'use strict';

(function () {
  angular.module('zp').constant('mixesGridStyle', {
    xl: [{
      "width": "350px",
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "350px",
      "height": "420px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "350px",
      "height": "420px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "350px",
      "height": "420px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "350px",
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "350px",
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }],
    l: [{
      "width": "275px",
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "275px",
      "height": "420px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "275px",
      "height": "420px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "275px",
      "height": "420px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "275px",
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": "275px",
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }]
  });
})();